// A child's places (docs/ORGANISER_PLAN.md §3.2, §4.3; mockup 07): want-to-go places, from the
// kit's ideas or a pasted map link, and check-ins. A check-in stores only whether the phone was
// near, never where it was: the position is compared once, on the phone.
import { z } from 'zod'

const id = z.string().regex(/^[a-z0-9][a-z0-9-]*$/, 'kebab-case id')

/** A place someone found themselves (a pasted link); kit places are named by id alone. */
export const OwnPlace = z.object({
  name: z.string().trim().min(1).max(80),
  at: z.tuple([z.number().min(-90).max(90), z.number().min(-180).max(180)]).optional(),
  url: z.string().url().max(2048).optional(),
})
export type OwnPlace = z.infer<typeof OwnPlace>

export const PlaceWanted = z.object({ placeId: id, place: OwnPlace.optional() })
export const PlaceUnwanted = z.object({ placeId: id })
/** Strict: a check-in that carries anything else (a position) is refused by the server. */
export const Checkin = z.object({ placeId: id, itemId: id.optional(), near: z.boolean() }).strict()
export type Checkin = z.infer<typeof Checkin>

export const PLACE_EVENTS = {
  'place.wanted': PlaceWanted,
  'place.unwanted': PlaceUnwanted,
  checkin: Checkin,
} as const
